import { create } from "zustand";
const useYDocsManager = create((set) => ({
  enable: true,
  id: "",
  yState: null,
  update: (key, value) =>
    set((state) => {
      //  console.log("Updating...", key,value)
      return {
        ...state,
        [key]: value,
      };
    }),
}));

export default useYDocsManager;
